import { render } from "./slide-verify.vue?vue&type=template&id=1bdefc83"
import script from "./slide-verify.vue?vue&type=script&lang=js"
export * from "./slide-verify.vue?vue&type=script&lang=js"

import "./slide-verify.vue?vue&type=style&index=0&id=1bdefc83&lang=less"

import exportComponent from "/Users/jixubin/thinkcloud/thinkcloud-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__